import { Controller } from "@hotwired/stimulus"

// Rollup row in the issues index. Click anywhere in the row toggles the
// <details>, except when the user clicks a genuinely interactive element
// (links, inputs, the summary itself) or a region marked
// `data-rollup-row-ignore`.
export default class extends Controller {
  static targets = ["details"]

  toggle(event) {
    // Skip clicks on interactive controls (native handlers run instead), on
    // the expanded children list (so users can read it without collapsing),
    // and on ignored regions such as the Linear ticket panel, whose selects and
    // padding would otherwise collapse the row mid-form.
    if (event.target.closest("a, input, button, label, summary, ul, select, [data-rollup-row-ignore]")) return;
    if (this.hasDetailsTarget) {
      this.detailsTarget.open = !this.detailsTarget.open;
    }
  }
}
